export default __webpack_public_path__ + "static/media/안주10.ead7a2c3.png";